import { render, staticRenderFns } from "./DeliverableStatusOverview.vue?vue&type=template&id=0ffe7fcd&"
import script from "./DeliverableStatusOverview.vue?vue&type=script&lang=js&"
export * from "./DeliverableStatusOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ffe7fcd')) {
      api.createRecord('0ffe7fcd', component.options)
    } else {
      api.reload('0ffe7fcd', component.options)
    }
    module.hot.accept("./DeliverableStatusOverview.vue?vue&type=template&id=0ffe7fcd&", function () {
      api.rerender('0ffe7fcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableStatusOverview.vue"
export default component.exports